export default [
    {
        path: 'relatorio-producao',
        component: () => import(
            /* webpackChunkName: 'exame-imagem-relatorio-producao' */
            '@/views/exame-imagem/relatorio-producao/Index'),
        redirect: 'relatorio-producao/index',
        children: [
            {
                name: 'exame-imagem-relatorio-producao-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'exame-imagem-relatorio-producao' */
                    '@/views/exame-imagem/relatorio-producao/List.vue'),
            },
        ],
    },
]